const tripStatus = {
    PENDING: "pending",
    MOVING: "moving", // Driver is moving to trip currentTripPoint
    COMPLETED: "completed",
    ARRIVED: "arrived",
    CANCELLED: "cancelled",
    NOT_REQUESTED: "not_requested",
    UNFULFILLED: "unfulfilled",
    NOT_LOADED: "not_loaded",
    ABSENT: "absent",
};

export const tripSource = {
    system: "system",
    manual: "manual",
};

export const isTerminationState = (state) =>
    state === tripStatus.COMPLETED ||
    state === tripStatus.NOT_REQUESTED ||
    state === tripStatus.UNFULFILLED ||
    state === tripStatus.NOT_LOADED ||
    state === tripStatus.CANCELLED ||
    state === tripStatus.ABSENT;

export default tripStatus;

export const stateActionValue = (state) =>
    ({
        complete: "completed",
        cancel: "canceled",
        not_requested: "not_requested",
        unfulfilled: "unfulfilled",
        not_loaded: "not_loaded",
        absent: "absent",
    }[state]);
